const moveoUrlMessage = ({ url, title }, avatar) =>
  `<li class="moveo__other"><img class="bot__image" src="${avatar}" /><a class="link__bubble" href="${url}" target="_blank">${
    title || url
  }</a></li>`;

export default moveoUrlMessage;
